import React from 'react';
import { NOT_LOGGED_IN_USER_ID } from "../constants";
export const spaConfigContextInitialState = {
  tenant: '',
  currentLanguage: '',
  globalApiUrl: '',
  graphqlUrl: '',
  identityUrl: '',
  languageCookieKey: '',
  languageSwitcherCookieKey: '',
  customerId: NOT_LOGGED_IN_USER_ID,
  useNewLayout: false,
  isFrontPage: false,
  clientAppsUrl: '',
  footer: {
    show: true,
    isStandalone: true
  },
  backInStockNotificationConfiguration: {
    notifyMeSubscriptionConfiguration: {
      IsEditionEnabled: true,
      IsSmsSubscriptionEnabled: false,
      ShowMarketingApprovalWarning: false,
      MarketingApprovalWarningText: '',
      IsCumulusMarket: true
    }
  },
  miniShoppingBagConfiguration: {
    basketLink: '/shopping/basket'
  },
  translations: {}
};
export const spaConfigContext = /*#__PURE__*/React.createContext(spaConfigContextInitialState);
//# sourceMappingURL=spaConfigContext.js.map